// ActionGroup (BL-189): a labelled row of small actions that wraps onto as many lines as it needs, its
// label in view above it: a message's "Put in", one action for each field it can fill in. Each action
// is a small secondary Button; pressing one does something, and nothing stays on. Not a choice
// (ChoiceGroup) or a switch of two to four (Segmented, which never wraps and labels itself for screen
// readers only). Reads only --actions-*; Button reads its own.
import { useId } from 'react';
import { Button } from '../Button/Button.tsx';
import './ActionGroup.css';

export interface GroupAction {
  id: string;
  /** Its words ("{{customer.firstName}}"). */
  label: string;
  isDisabled?: boolean;
}

export interface ActionGroupProps {
  /** Its heading, shown ("Put in"). */
  label: string;
  items: readonly GroupAction[];
  onAction: (id: string) => void;
}

export function ActionGroup({ label, items, onAction }: ActionGroupProps) {
  const id = useId();
  return (
    <div className="fl-actions" role="group" aria-labelledby={id}>
      <span className="fl-actions__label" id={id}>
        {label}
      </span>
      <div className="fl-actions__list">
        {items.map((a) => (
          <Button key={a.id} size="sm" isDisabled={a.isDisabled} onPress={() => onAction(a.id)}>
            {a.label}
          </Button>
        ))}
      </div>
    </div>
  );
}
